<lvr-heading>
	{{ 'client.documents.title' | transloco }} {{ client()?.name
	}}{{ client()?.firstName ? ', ' + client()?.firstName : '' }}
	@if (client()?.dateOfBirth) {
		*{{ client()?.dateOfBirth | date: dateDisplayFormat }}
	}
</lvr-heading>

<h3 lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'client.documents.document_templates' | transloco }}</h3>
<lvr-templates-list [templates]="templates()"></lvr-templates-list>

<lvr-spacer [color]="'#000000'" [height]="0" [margin]="'32px 0 16px 0'"></lvr-spacer>

<h3 lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'client.documents.documents' | transloco }}</h3>
@if (clientId()) {
	<lvr-documents-list [clientId]="clientId()!" [initialDocumentsPage]="documents()"></lvr-documents-list>
}
